module.exports = __webpack_public_path__ + "assets/T3_PointDetailed.265a4ce127c5bfb8f7d37adaae03d1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/T3_PointDetailed.png
// module id = 574
// module chunks = 0